import React, { useEffect } from 'react';
import { Button, Result } from 'antd';
import { useParams } from 'react-router-dom';
import axios from 'axios';

const PunchOut = ({

}) => {
    const { state } = useParams()
    // useEffect(()=>{
    //     axios
    //         .post('/cramSchool/api/punch_out',[
    //             {
    //                 patrol_location_punch_value:state
    //             }
    //         ])
    // },[])
    return (<>
        <Result
            status="success"
            title="簽到完成"
            // extra={[
            //     <Button >
            //         返回首頁
            //     </Button>,
            // ]}
        />
    </>)
}
export default PunchOut;